import { Component } from "react";
import PropTypes from "prop-types";
import { Icon } from "@evertrue/et-components";
import moment from "moment";
import EverTrue from "app";
import { TodoShapePropTypes } from "apps/todo/todo-prop-types";
import { ReminderShapePropTypes } from "apps/todo/reminder-prop-types";
import classNames from "classnames";
import TodoDateSelectionCalendar from "apps/todo/components/todo-date-selection-calendar";
import { OutsideClick, Button, IconButton } from "@evertrue/et-components";
import UserSelector from "apps/users/components/user-selector";
import WithSession from "base/session/with-session";
import _ from "underscore";

class TodoForm extends Component {
  static propTypes = {
    todo: TodoShapePropTypes,
    reminder: ReminderShapePropTypes,
    clearForm: PropTypes.func,
    createTodo: PropTypes.func,
    updateTodo: PropTypes.func,
    editMode: PropTypes.bool,
    deleteTodo: PropTypes.func,
    createReminder: PropTypes.func.isRequired,
    editReminder: PropTypes.func,
    deleteReminder: PropTypes.func,
    session: PropTypes.object,
  };

  static defaultProps = {
    todo: {},
    reminder: {},
    clearForm: () => {},
    createTodo: () => {},
    updateTodo: () => {},
    editMode: false,
    deleteTodo: () => {},
    editReminder: () => {},
    deleteReminder: () => {},
    session: {},
  };

  state = {
    todo: this.props.todo,
    reminder: this.props.reminder,
    showDueDateCalander: false,
    showRemindersCalendar: false,
    selected_asignee: {},
  };

  componentDidMount() {
    // we are doinn this so that user can see his own name as Assignee in the form
    this.setState((state) => ({
      selected_asignee: { value: this.props.session.user.id, label: this.props.session.user.name },
    }));
  }

  handleChanage = (key, value) => {
    this.setState((state) => ({ todo: { ...state.todo, [key]: value } }));
  };

  newDueDateSelected = (date) => {
    const millisecond_date = date ? moment(date).valueOf() : null;
    this.setState((state) => ({ todo: { ...state.todo, due_date: millisecond_date } }));
  };

  closeDueDateCalander = () => {
    this.toggleDateCalendar("showDueDateCalander");
  };

  newReminderDateSelected = (date) => {
    const millisecond_date = date ? moment(date).valueOf() : null;
    const new_reminder = { ...this.state.reminder, remind_at: millisecond_date };
    this.setState({ reminder: new_reminder });
  };

  closeReminderCalander = () => {
    this.toggleDateCalendar("showRemindersCalendar");
  };

  clearDueDateClicked = () => {
    this.setState((state) => ({ todo: { ...state.todo, due_date: null } }));
    this.toggleDateCalendar("showDueDateCalander");
  };
  clearReminderClicked = () => {
    this.setState((state) => ({
      reminder: {
        ...state.reminder,
        remind_at: null,
      },
    }));
    this.toggleDateCalendar("showRemindersCalendar");
  };

  calendarOutsidesClicked = () => {
    this.setState({
      showRemindersCalendar: false,
      showDueDateCalander: false,
    });
  };

  toggleDateCalendar = (key) => {
    this.setState((state) => {
      return { [key]: !state[key] };
    });
  };

  createTodo = async () => {
    const todo = await this.props.createTodo(this.state.todo);
    await this.createReminder(todo.id);
    EverTrue.Alert.success("Successfully created");
  };

  createReminder = (task_id) => {
    const { remind_at } = this.state.reminder;
    if (remind_at) {
      const new_reminder = {
        ...this.state.reminder,
        task_id,
        send_email: true,
        send_push: true,
      };
      return this.props.createReminder(new_reminder);
    }
    return Promise.resolve();
  };

  updateTodo = async () => {
    const { todo: current_todo } = this.state;
    if (!_.isEqual(current_todo, this.props.todo)) {
      await this.props.updateTodo(current_todo);
    }

    await this.updateReminder(current_todo.id);
    this.props.clearForm();
    EverTrue.Alert.success("Successfully updated");
  };

  updateReminder = async (todo) => {
    const {
      reminder: { remind_at, id: reminder_id },
      todo: { id: task_id },
    } = this.state;
    const {
      reminder: { remind_at: prev_remind_at },
    } = this.props;

    if (!reminder_id && remind_at) {
      return this.createReminder(task_id);
    } else if (remind_at && remind_at !== prev_remind_at) {
      return this.props.editReminder(this.state.reminder);
    } else if (prev_remind_at && !remind_at) {
      return this.props.deleteReminder(reminder_id, task_id);
    }
  };

  selectedAsigneeChanged = (asignee_user) => {
    this.setState((state) => ({
      todo: { ...state.todo, assignee_user_id: asignee_user.value },
      selected_asignee: asignee_user,
    }));
  };

  renderDueDateBottomComponent = () => {
    return (
      <div className="todo-date-selection--button-wrapper">
        <Button
          type="simple"
          title="Clear due date"
          className="todo-date-selection--clear-button"
          onClick={this.clearDueDateClicked}
        >
          Clear Due Date
        </Button>
        <Button
          type="simple"
          title="Done"
          className="todo-date-selection--done-button"
          onClick={this.closeDueDateCalander}
        >
          Done
        </Button>
      </div>
    );
  };

  renderReminderBottomComponent = () => {
    return (
      <div className="todo-date-selection--button-wrapper">
        <Button
          type="simple"
          title="Clear the To-Do reminder"
          className="todo-date-selection--clear-button"
          onClick={this.clearReminderClicked}
        >
          Clear Reminder
        </Button>
        <Button
          type="simple"
          title="Done"
          className="todo-date-selection--done-button"
          onClick={this.closeReminderCalander}
        >
          Done
        </Button>
      </div>
    );
  };
  render() {
    const { remind_at } = this.state.reminder;
    const due_month_date_day = this.state.todo.due_date
      ? moment(this.state.todo.due_date).format("MMM DD ddd")
      : "Set DueDate";
    const reminder_month_date_day = remind_at ? moment(remind_at).format("MMM DD hh:mma") : "Set Reminder";
    const submit_disabled = !this.state.todo.summary;
    const wrapper_class = classNames("todo-add--wrapper", { "todo-add--wrapper-in-edit-mode": this.props.editMode });
    const form_holder_class = classNames("todo-add--form-holder", {
      "todo-add--form-holder-in-edit-mode": this.props.editMode,
    });
    return (
      <div className={wrapper_class}>
        <form className={form_holder_class} onSubmit={(e) => e.preventDefault()}>
          <input
            className="todo-add--title"
            placeholder="Enter New To-Do*"
            value={this.state.todo.summary}
            onChange={(e) => this.handleChanage("summary", e.target.value)}
          />
          <UserSelector onChange={this.selectedAsigneeChanged} selected={this.state.selected_asignee} />
          <div className="todo-add--date-holder">
            <div className="todo-add--duedate-holder">
              <Icon icon="event" />
              <Button
                type="simple"
                title="Show due date calendar"
                disabled={this.state.showDueDateCalander}
                className="todo-add--duedate"
                onClick={() => this.toggleDateCalendar("showDueDateCalander")}
              >
                {due_month_date_day}
              </Button>
              {this.state.showDueDateCalander && (
                <OutsideClick onOutsideClick={this.calendarOutsidesClicked}>
                  <TodoDateSelectionCalendar
                    selectedDate={this.state.todo.due_date}
                    className="todo-form--extra-style"
                    bottomComponent={this.renderDueDateBottomComponent()}
                    newDateSelected={this.newDueDateSelected}
                    clockEnabled={false}
                  />
                </OutsideClick>
              )}
            </div>
            <div className="todo-add--reminder-holder">
              <Icon icon="alarm" />
              <Button
                type="simple"
                title="Show reminder calendar"
                disabled={this.state.showRemindersCalendar}
                className="todo-add--reminder"
                onClick={() => this.toggleDateCalendar("showRemindersCalendar")}
              >
                {reminder_month_date_day}
              </Button>
              {this.state.showRemindersCalendar && (
                <OutsideClick onOutsideClick={this.calendarOutsidesClicked}>
                  <TodoDateSelectionCalendar
                    selectedDate={remind_at}
                    className="todo-form--extra-style"
                    bottomComponent={this.renderReminderBottomComponent()}
                    newDateSelected={this.newReminderDateSelected}
                    clockEnabled={true}
                  />
                </OutsideClick>
              )}
            </div>
          </div>
          <div className="todo-add--description-holder">
            <div className="todo-add--description-icon">
              <Icon icon="notes" />
            </div>
            <div className="todo-add--description-input">
              <textarea
                className="todo-add--description"
                placeholder="Add Notes..."
                value={this.state.todo.description}
                onChange={(e) => this.handleChanage("description", e.target.value)}
              />
            </div>
          </div>
          <div className="todo-add--action-button-section">
            <div>
              {this.props.editMode && (
                <IconButton
                  title="delete to do"
                  className="todo-add--delete-button"
                  icon="delete"
                  onClick={() => this.props.deleteTodo(this.state.todo.id)}
                />
              )}
            </div>
            <div className="todo-add--submit-button-div">
              <Button type="simple" title="Cancel" onClick={() => this.props.clearForm()}>
                Cancel
              </Button>
              {!this.props.editMode ? (
                <Button
                  title="Create To-Do"
                  disabled={submit_disabled}
                  className="todo-add--submit-button"
                  onClick={() => this.createTodo()}
                >
                  Add
                </Button>
              ) : (
                <Button
                  disabled={submit_disabled}
                  title="Update the To-Do"
                  className="todo-add--submit-button"
                  onClick={() => this.updateTodo()}
                >
                  Save
                </Button>
              )}
            </div>
          </div>
        </form>
      </div>
    );
  }
}

export default WithSession(TodoForm);
